export enum NeutralAttackAttribute {
  IllegalTouch = 873,
  Zone1 = 874,
  Zone2 = 875,
  Zone3 = 876,
  Zone4 = 877,
  Zone5 = 878,
  Zone6 = 879,
  BlockedBack = 880,
}
